<script setup lang="ts">
import { computed } from "vue";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog/index";

interface Props {
  open: boolean;
  busy: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  "update:open": [value: boolean];
  confirm: [];
}>();

const modelOpen = computed({
  get: () => props.open,
  set: (value: boolean) => emit("update:open", value),
});
</script>

<template>
  <AlertDialog v-model:open="modelOpen">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>¿Archivar hilo?</AlertDialogTitle>
        <AlertDialogDescription>
          Este cambio impacta a todos los participantes.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <ul class="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
        <li>Se archiva para todos los participantes.</li>
        <li>Se oculta de la lista de hilos activos.</li>
        <li>Se silencian notificaciones mientras siga archivado.</li>
        <li>Solo se desarchiva manualmente desde el switch de metadata.</li>
      </ul>
      <AlertDialogFooter>
        <AlertDialogCancel :disabled="busy">Cancelar</AlertDialogCancel>
        <AlertDialogAction :disabled="busy" @click="emit('confirm')">
          Confirmar
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
